import * as Sentry from '@sentry/react';

export function initSentry(SERVER_ENV) {
  const dsn = import.meta.env.VITE_SENTRY_FRONTEND_DSN;
  if ( SERVER_ENV !== 'production' ) return; // Don't run sentry in another env than production

  Sentry.init({
    dsn,

    // Performance: traces 20% of transactions
    tracesSampleRate: 0.2,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    // Session Replay: visually records what happened before a crash
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    replaysSessionSampleRate: 0.1, // 10% of normal sessions

    denyUrls: [
      // Firebase Analytics + Installations are routinely blocked by ad blockers
      // and corporate firewalls. The SDK does not handle the rejection, so it
      // surfaces as an unhandled promise rejection — pure noise, no user impact.
      /firebase\.googleapis\.com/,
      /firebaseinstallations\.googleapis\.com/,
    ],
  });
}
